import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import { MemberService } from "service/member/service";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Modal,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import { channel } from "./data/Member";
import DataTable from "examples/Tables/DataTable";
import { GRADE_TYPE } from "service/coupon/service";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const loginTypeMap = {
  C: "일반회원",
  K: "카카오",
  N: "네이버",
  G: "구글",
};
function MemberList(): JSX.Element {
  const [landingType, setLandingType] = useState("");
  const [tableData, setTableData] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [signdata, setsigndata] = useState({
    email: "",
    password: "",
    name: "",
    birthDate: "",
    gender: "",
    phone_1st: "",
    phone_2nd: "",
    category: "",
    agriculturalNum: "",
  });

  const [updatedata, setupdatedata] = useState({
    email: "",
    password: "",
    name: "",
    birthDate: "",
    gender: "",
    phone_1st: "",
    phone_2nd: "",
    category: "",
    agriculturalNum: "",
    isDeleted: "",
    isAdmin: "",
    createdDate: "",
    leftPoint: "",
    lastVisitTime: "",
    visitCount: "",
    recentService: "",
    loginLog: [],
    chargeList: [],
    freePointList: [],
  });
  const [userKey, setUserKey] = useState("");
  const [utmData, setUtmData] = useState({
    utm_campaign: "",
    utm_content: "",
    utm_id: "",
    utm_medium: "",
    utm_source: "",
  });
  const [referrer, setReferrer] = useState("");
  const [category1, setCategory1] = useState("A");
  const [channelType, setChannelType] = useState(["A"]);
  const [category2, setCategory2] = useState("A");
  const [category3, setCategory3] = useState("A");
  const [category4, setCategory4] = useState("A");
  const [limit, setlimit] = useState(10);
  const [totalcount, settotalcount] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [search, setSearch] = useState("");
  const offset = (currentPage - 1) * limit;
  const [sortType, setSortType] = useState("RD");

  const [detailOpen, setdetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const list = async (
    channelType: string[],
    search: string,
    sort: string,
    startDate: string,
    endDate: string,
    limit: number,
    offset: number
  ) => {
    try {
      const loginType = channelType.includes("A") ? "" : channelType.join(",");
      const res = await MemberService.list2(
        loginType,
        search,
        sort,
        startDate,
        endDate,
        limit,
        offset
      );
      setTableData(res.list);
      settotalcount(res.total_count);
      setTotalPages(Math.ceil(res.total_count / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const create = async () => {
    // try {
    //   await MemberService.create(signdata);
    //   setOpen(false);
    //   // list 초기화
    //   list("A", "", startDate, endDate, limit, 0);
    // } catch (err) {
    //   console.log(err);
    // }
  };

  const update = async () => {
    // try {
    //   await MemberService.update(updatedata, userKey);
    //   setOpen2(false);
    //   list(category1, search, startDate, endDate, limit, offset);
    // } catch (err) {
    //   console.log(err);
    // }
  };

  const view = async (userKey: string) => {
    try {
      // const res = await MemberService.view(userKey);
      setUserKey(userKey);
      // setupdatedata({
      //   email: res.email,
      //   password: "",
      //   name: res.name,
      //   birthDate: res.birthYear,
      //   gender: res.gender,
      //   phone_1st: res.phone && res.phone.split("-")[1],
      //   phone_2nd: res.phone && res.phone.split("-")[2],
      //   category: res.category,
      //   agriculturalNum: res.agriculturalNum,
      //   isDeleted: res.isDeleted,
      //   isAdmin: res.isAdmin,
      //   createdDate: res.createdDate,
      //   leftPoint: res.leftPoint,
      //   lastVisitTime: res.lastVisitTime,
      //   visitCount: res.visitCount,
      //   recentService: res.recentService,
      //   loginLog: res.loginLog,
      //   chargeList: res.chargeList,
      //   freePointList: res.freePointList,
      // });

      // setUtmData(res.referer);
      setOpen2(true);
      // setReferrer(res.fullReferer);
      // setLandingType(res.landing);
    } catch (err) {
      console.log(err);
    }
  };

  const csv = async () => {
    try {
      const loginType = channelType.includes("A") ? "" : channelType.join(",");
      const a = document.createElement("a");
      a.href = `${process.env.REACT_APP_HOST}admin/csv1?startDate=${startDate}&endDate=${endDate}&loginType=${loginType}&search=${search}&sort=${sortType}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };

  const onChange = (e: any) => {
    setsigndata((prev) => {
      return { ...prev, [e.target.id]: e.target.value };
    });
  };
  const onChange2 = (e: any) => {
    setupdatedata((prev) => {
      return { ...prev, [e.target.id]: e.target.value };
    });
  };

  const openSign = () => {
    setsigndata({
      email: "",
      password: "",
      name: "",
      birthDate: "",
      gender: "",
      phone_1st: "",
      phone_2nd: "",
      category: "",
      agriculturalNum: "",
    });
    setOpen(true);
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    setCurrentPage(1);
    list(channelType, search, sortType, startDate, endDate, limit, 0);
  }, [channelType, startDate, endDate, sortType]);

  useEffect(() => {
    list(channelType, search, sortType, startDate, endDate, limit, limit * (currentPage - 1));
  }, [currentPage]);

  return (
    <DashboardLayout>
      {modal1(open, setOpen, signdata, onChange, setsigndata, create)}
      {modal2(
        open2,
        setOpen2,
        updatedata,
        onChange2,
        setupdatedata,
        update,
        utmData,
        referrer,
        landingType
      )}
      {detailOpen && userDetailModal(detailOpen, setdetailOpen, detailData)}
      <DashboardNavbar />
      <MDBox my={3}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: "16px",
            padding: "0 8px",
          }}
        >
          <div
            style={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "white",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={csv}
            role="button"
          >
            <Icon>description</Icon>
            CSV 다운로드
          </div>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <MDButton color="success" onClick={openSign}>
              회원 추가
            </MDButton>
          </div> */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {/* <div
              style={{
                display: "flex",
                gap: "8px",
                width: "100%",
                justifyContent: "space-around",
                whiteSpace: "nowrap",
              }}
            > */}
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                검색어
              </span>
              <input
                type="text"
                placeholder="이메일, 성명, 연락처"
                style={{ padding: "8px" }}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "rgb(30, 155, 107)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "white",
                  borderRadius: "8px",
                  width: "80px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentPage(1);
                  list(channelType, search, sortType, startDate, endDate, limit, 0);
                }}
              >
                검색
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
                whiteSpace: "nowrap",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                가입채널
              </span>
              <Select
                labelId="promotion-type-label"
                multiple
                variant="outlined"
                value={channelType}
                onChange={(e) => {
                  let value = e.target.value as string[];
                  console.log(value);
                  if (value.length === 0) {
                    setChannelType(["A"]);
                    return;
                  }

                  if (value[value.length - 1] === "A") {
                    setChannelType(["A"]);
                    return;
                  }
                  if (value.includes("A") && value.length > 1) {
                    setChannelType(value.filter((v) => v !== "A"));
                    return;
                  }

                  setChannelType(value.filter((v) => v !== "A"));

                  console.log(channelType);
                }}
                style={{
                  width: "150px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
                sx={{
                  width: 150,
                  padding: "8px 0",
                  "& .MuiSelect-select": {
                    width: 120,
                    whiteSpace: "nowrap !important",
                    overflow: "hidden !important",
                    textOverflow: "ellipsis !important",
                    display: "block !important",
                    padding: 0,
                  },
                  "& .MuiSelect-icon": {
                    display: "block",
                  },
                }}
              >
                {channel.map((el) => (
                  <MenuItem key={el.value} value={el.value}>
                    {el.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                정렬 기준
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSortType(e.target.value)}
              >
                {sortData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            {/* <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  직업
                </span>
                <select
                  name=""
                  id=""
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setCategory2(e.target.value)}
                >
                  {job.map((el, index) => (
                    <option value={el.value} key={index}>
                      {el.label}
                    </option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  유입매체
                </span>
                <select
                  name=""
                  id=""
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setCategory3(e.target.value)}
                >
                  {media.map((el, index) => (
                    <option value={el.value} key={index}>
                      {el.label}
                    </option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  랜딩페이지
                </span>
                <select
                  name=""
                  id=""
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setCategory4(e.target.value)}
                >
                  {landing.map((el, index) => (
                    <option value={el.value} key={index}>
                      {el.label}
                    </option>
                  ))}
                </select>
              </div> */}

            <div style={{ gap: "16px", display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  시작일 선택
                </span>
                <input
                  type="date"
                  value={startDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setStartDate(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  종료일 선택
                </span>
                <input
                  type="date"
                  value={endDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        <div style={{ marginTop: "24px", width: "100%" }}>
          <Card>
            <div style={{ padding: "24px 16px", width: "100%", overflowX: "auto" }}>
              <table style={{ width: window.innerWidth > 1300 ? "100%" : 1300 }}>
                <thead style={{ width: "100%" }}>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      display: "flex",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                      alignItems: "center",
                    }}
                  >
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 250 }}>ID</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 250 }}>이메일</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>가입채널</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>이름</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 150 }}>연락처</th>
                    {/* <th style={{ width: window.innerWidth > 1300 ? "100%" : 150 }}>직업</th> */}
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 200 }}>가입일자</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 200 }}>최종방문일자</th>
                    {/* <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>유입 매체</th> */}
                    {/* <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>랜딩페이지</th> */}
                    {/* <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>탈퇴</th> */}
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>회원등급</th>
                    <th style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>상세보기</th>
                  </tr>
                </thead>
                <tbody style={{ width: "100%" }}>
                  {tableData.map((el: any) => (
                    <tr
                      key={el.userid}
                      style={{
                        fontSize: 12,
                        color: "#000000DE",
                        width: "100%",
                        display: "flex",
                        textAlign: "center",
                        fontFamily: "Pretendard",
                        borderBottom: "1px solid #0000001A",
                        padding: "16px 0",
                        alignItems: "center",
                      }}
                    >
                      <td
                        style={{
                          width: window.innerWidth > 1300 ? "100%" : 250,
                        }}
                      >
                        {el.login_type === "C"
                          ? el.userid
                          : loginTypeMap[el.login_type as keyof typeof loginTypeMap]}
                      </td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 250 }}>{el.email}</td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                        {loginTypeMap[el.login_type as keyof typeof loginTypeMap]}
                      </td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>{el.name}</td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 150 }}>{el.tel}</td>
                      {/* <td style={{ width: window.innerWidth > 1300 ? "100%" : 150 }}>
                          {el.category}
                        </td> */}
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 200 }}>
                        {el.created_at}
                      </td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 200 }}>
                        {(el.last_login && el.last_login.split("T")[0]) || "-"}
                      </td>
                      {/* <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                          {el.referer ? JSON.parse(el.referer).utm_source : "-"}
                        </td>
                        <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                          {el.landing}
                        </td> */}
                      {/* <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                          {el.state === "Y" ? "N" : "Y"}
                        </td> */}
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                        {el.plan_grade
                          ? GRADE_TYPE[el.plan_grade as keyof typeof GRADE_TYPE] ?? el.plan_grade
                          : "-"}
                      </td>
                      <td style={{ width: window.innerWidth > 1300 ? "100%" : 100 }}>
                        <MDButton
                          onClick={() => {
                            setDetailData(el);
                            setdetailOpen(true);
                          }}
                        >
                          상세보기
                        </MDButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="secondary"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      "&.Mui-selected": {
                        backgroundColor: "#1e9b6b",
                        color: "white",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "#1e9b6b",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </Card>
        </div>
      </MDBox>
    </DashboardLayout>
  );
}
export default MemberList;

// 회원 정보 보기 모달
function modal2(
  open2: boolean,
  setOpen2: any,
  updatedata: {
    email: string;
    password: string;
    name: string;
    birthDate: string;
    gender: string;
    phone_1st: string;
    phone_2nd: string;
    category: string;
    agriculturalNum: string;
    isDeleted: string;
    isAdmin: string;
    createdDate: string;
    leftPoint: string;
    lastVisitTime: string;
    visitCount: string;
    recentService: string;
    loginLog: Array<{ ip: string; loginTime: string }>;
    chargeList: Array<{ pointTime: string; paidAmount: number; description: string }>;
    freePointList: Array<{ pointTime: string; freePoint: number; description: string }>;
  },
  onChange2: (e: any) => void,
  setupdatedata: any,
  update: () => Promise<void>,
  utmData: any,
  referrer?: string,
  landingType?: string
) {
  const formattedDate = (dateString: string) => {
    return dateString.replace("T", " ").replace(".000Z", "");
  };

  return (
    <Modal
      open={open2}
      onClose={() => setOpen2(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        padding: "40px",
        overflowY: "auto",
      }}
    >
      <MDBox
        bgColor="white"
        p="32px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="32px"
        justifyContent="center"
        width="600px"
      >
        <MDBox
          borderBottom="1px solid lightgrey"
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            1. 가입 정보
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              이메일
            </Typography>
            <MDInput
              value={updatedata.email}
              onChange={onChange2}
              id="email"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              이름
            </Typography>
            <MDInput
              value={updatedata.name}
              onChange={onChange2}
              id="name"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              연락처
            </Typography>
            <MDBox display="flex" flex="1" gap="8px" alignItems="center">
              <MDInput
                value={"010"}
                flex="0.5"
                InputProps={{ maxLength: 4 }}
                style={{ maxLength: 3 }}
              />
              <Typography flex="0.5">-</Typography>
              <MDInput
                value={updatedata.phone_1st}
                onChange={onChange2}
                id="phone_1st"
                flex="0.5"
                InputProps={{ maxLength: 4 }}
                style={{ maxLength: 3 }}
              />
              <Typography flex="0.5">-</Typography>
              <MDInput
                value={updatedata.phone_2nd}
                onChange={onChange2}
                id="phone_2nd"
                flex="0.5"
              />
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              가입채널
            </Typography>
            <MDInput
              value={updatedata.category}
              onChange={onChange2}
              id="category"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              가입일시
            </Typography>
            <MDInput
              value={formattedDate(updatedata.createdDate)}
              onChange={onChange2}
              id="regdate"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              직업
            </Typography>
            <MDBox flex="1">
              <FormControl fullWidth sx={{ height: "44px" }}>
                <InputLabel id="options-select-label" sx={{ height: "44px" }}>
                  선택
                </InputLabel>
                <Select
                  sx={{ height: "44px" }}
                  labelId="options-select-label"
                  value={updatedata.category}
                  onChange={(e: any) => {
                    setupdatedata((prev: any) => {
                      return { ...prev, category: e.target.value };
                    });
                  }}
                  label="선택"
                >
                  <MenuItem value="W">농업인</MenuItem>
                  <MenuItem value="F">귀농 희망자</MenuItem>
                  <MenuItem value="N">귀촌 희망자</MenuItem>
                  <MenuItem value="E">농산업기업체</MenuItem>
                  <MenuItem value="O">지자체 담당자</MenuItem>
                  <MenuItem value="P">정부부처(공공기관)</MenuItem>
                  <MenuItem value="G">일반인</MenuItem>
                  <MenuItem value="C">농산물 유통</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </MDBox>
        <MDBox
          borderBottom={"1px solid lightgrey"}
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            2. 등급 정보(기준 미정)
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              회원 등급
            </Typography>
            <MDInput value={"-"} onChange={onChange2} id="level" style={{ width: "264px" }} />
          </MDBox>
        </MDBox>
        <MDBox
          borderBottom={"1px solid lightgrey"}
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            3. 이용 정보
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              최근 이용 서비스
            </Typography>
            <MDInput
              value={updatedata.recentService}
              onChange={onChange2}
              id=""
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              방문 횟수
            </Typography>
            <MDInput
              value={updatedata.visitCount}
              onChange={onChange2}
              id=""
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              보유 포인트
            </Typography>
            <MDInput
              value={Number(updatedata.leftPoint)}
              onChange={onChange2}
              id=""
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              충전 및 환불내역
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {updatedata.chargeList &&
                updatedata.chargeList.map((el: any, index: any) => {
                  return (
                    <MDBox display="flex" gap="8px" key={index}>
                      <Typography variant="caption" fontWeight={500}>
                        {formattedDate(el.pointTime)}
                      </Typography>
                      <Typography variant="caption" fontWeight={500}>
                        {el.paidPoint}
                      </Typography>
                      <Typography variant="caption" fontWeight={500}>
                        {el.description}
                      </Typography>
                    </MDBox>
                  );
                })}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              무료 포인트 지급 내역
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {updatedata.freePointList &&
                updatedata.freePointList.map((el: any, index: any) => {
                  return (
                    <MDBox display="flex" gap="8px" key={index}>
                      <Typography variant="caption" fontWeight={500}>
                        {formattedDate(el.pointTime)}
                      </Typography>
                      <Typography variant="caption" fontWeight={500}>
                        {el.freePoint}
                      </Typography>
                      <Typography variant="caption" fontWeight={500}>
                        {el.description}
                      </Typography>
                    </MDBox>
                  );
                })}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              접속 정보
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {updatedata.loginLog &&
                updatedata.loginLog.map((el: any, index: any) => {
                  return (
                    <MDBox display="flex" gap="8px" key={index}>
                      <Typography variant="caption" fontWeight={500}>
                        {formattedDate(el.loginTime)}
                      </Typography>
                      <Typography variant="caption" fontWeight={500}>
                        IP: {el.ip}
                      </Typography>
                    </MDBox>
                  );
                })}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              landingType
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {landingType ? landingType : "-"}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              utmsource
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {utmData ? utmData.utm_source : "-"}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              utmcontent
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {utmData ? utmData.utm_content : "-"}
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center" style={{ wordBreak: "break-all" }}>
            <Typography variant="body2" fontWeight={500} flex="1">
              referrer
            </Typography>
            <MDBox display="flex" flexDirection="column" gap="8px" style={{ width: "264px" }}>
              {referrer ? referrer : "-"}
            </MDBox>
          </MDBox>
        </MDBox>
        <MDBox
          borderBottom={"1px solid lightgrey"}
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            4.활동 중지
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              어드민
            </Typography>
            <Switch
              checked={updatedata.isAdmin === "Y"}
              onClick={() =>
                setupdatedata((prev: any) => {
                  return { ...prev, isAdmin: prev.isAdmin === "Y" ? "N" : "Y" };
                })
              }
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              탈퇴
            </Typography>
            <Switch
              checked={updatedata.isDeleted === "Y"}
              onClick={() =>
                setupdatedata((prev: any) => {
                  return { ...prev, isDeleted: prev.isDeleted === "Y" ? "N" : "Y" };
                })
              }
            />
          </MDBox>
        </MDBox>
        <MDButton
          color={
            updatedata.email ||
            updatedata.name ||
            updatedata.birthDate ||
            updatedata.gender ||
            updatedata.phone_1st ||
            updatedata.phone_2nd ||
            updatedata.category
              ? "success"
              : "light"
          }
          onClick={
            updatedata.email ||
            updatedata.name ||
            updatedata.birthDate ||
            updatedata.gender ||
            updatedata.phone_1st ||
            updatedata.phone_2nd ||
            updatedata.category ||
            updatedata.isAdmin ||
            updatedata.isDeleted
              ? update
              : () => alert("내용을 입력해주세요")
          }
        >
          수정 하기
        </MDButton>
      </MDBox>
    </Modal>
  );
}
// 회원 추가 모달
function modal1(
  open: boolean,
  setOpen: any,
  signdata: {
    email: string;
    password: string;
    name: string;
    birthDate: string;
    gender: string;
    phone_1st: string;
    phone_2nd: string;
    category: string;
    agriculturalNum: string;
  },
  onChange: (e: any) => void,
  setsigndata: any,
  create: () => Promise<void>
) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        padding: "32px",
        overflowY: "auto",
      }}
    >
      <MDBox
        bgColor="white"
        p="32px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="32px"
        justifyContent="center"
        width="600px"
      >
        <MDBox
          borderBottom="1px solid lightgrey"
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            1. 가입 정보
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              이메일
            </Typography>
            <MDInput
              value={signdata.email}
              onChange={onChange}
              id="email"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              비밀번호
            </Typography>
            <MDInput
              value={signdata.password}
              onChange={onChange}
              id="password"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              이름
            </Typography>
            <MDInput
              value={signdata.name}
              onChange={onChange}
              id="name"
              style={{ width: "264px" }}
            />
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              연락처
            </Typography>
            <MDBox display="flex" flex="1" gap="8px" alignItems="center">
              <MDInput
                value={"010"}
                flex="0.5"
                InputProps={{ maxLength: 4 }}
                style={{ maxLength: 3 }}
              />
              <Typography flex="0.5">-</Typography>
              <MDInput
                value={signdata.phone_1st}
                onChange={onChange}
                id="phone_1st"
                flex="0.5"
                InputProps={{ maxLength: 4 }}
                style={{ maxLength: 3 }}
              />
              <Typography flex="0.5">-</Typography>
              <MDInput value={signdata.phone_2nd} onChange={onChange} id="phone_2nd" flex="0.5" />
            </MDBox>
          </MDBox>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              성별
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup
                id="gender"
                aria-label="gender"
                name="gender"
                value={signdata.gender}
                onChange={(e) => {
                  setsigndata((prev: any) => {
                    return { ...prev, gender: e.target.value };
                  });
                }}
                row // row 속성을 사용하여 라디오 버튼을 가로로 나열
              >
                <FormControlLabel value="M" control={<Radio />} label="남자" />
                <FormControlLabel value="W" control={<Radio />} label="여자" />
              </RadioGroup>
            </FormControl>
          </MDBox>
        </MDBox>
        <MDBox
          borderBottom="1px solid lightgrey"
          display="flex"
          flexDirection="column"
          gap="16px"
          paddingBottom="32px"
        >
          <Typography variant="h5" flex="1">
            2. 회원 유형
          </Typography>
          <MDBox display="flex" gap="8px" alignItems="center">
            <Typography variant="body2" fontWeight={500} flex="1">
              직업
            </Typography>
            <MDBox flex="1">
              <FormControl fullWidth sx={{ height: "44px" }}>
                <InputLabel id="options-select-label" sx={{ height: "44px" }}>
                  선택
                </InputLabel>
                <Select
                  sx={{ height: "44px" }}
                  labelId="options-select-label"
                  value={signdata.category}
                  onChange={(e: any) => {
                    setsigndata((prev: any) => {
                      return { ...prev, category: e.target.value };
                    });
                  }}
                  label="선택"
                >
                  <MenuItem value="W">농업인</MenuItem>
                  <MenuItem value="F">귀농 희망자</MenuItem>
                  <MenuItem value="N">귀촌 희망자</MenuItem>
                  <MenuItem value="E">농산업기업체</MenuItem>
                  <MenuItem value="O">지자체 담당자</MenuItem>
                  <MenuItem value="P">정부부처(공공기관)</MenuItem>
                  <MenuItem value="G">일반인</MenuItem>
                  <MenuItem value="C">농산물 유통</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </MDBox>
        {/* <MDBox display="flex" gap="8px" alignItems="center">
          <Typography flex="1">생년월일</Typography>
          <MDInput value={signdata.birthDate} onChange={onChange} id="birthDate" flex="1" />
        </MDBox>
        <MDBox display="flex" gap="8px" alignItems="center">
          <Typography flex="1">농업경영체번호</Typography>
          <MDInput
            value={signdata.agriculturalNum}
            onChange={onChange}
            id="agriculturalNum"
            flex="1"
          />
        </MDBox> */}
        {/* <MDBox display="flex" gap="8px" alignItems="center">
          <Typography flex="1">어드민</Typography>
          <Switch
            checked={"Y" === "Y"}
            // onClick={() => setisDisplay(isDisplay === "Y" ? "N" : "Y")}
          />
        </MDBox> */}
        <MDButton
          color={
            signdata.email &&
            signdata.password &&
            signdata.name &&
            signdata.phone_1st &&
            signdata.phone_2nd &&
            signdata.category
              ? "info"
              : "light"
          }
          onClick={
            signdata.email &&
            signdata.password &&
            signdata.name &&
            signdata.phone_1st &&
            signdata.phone_2nd &&
            signdata.category
              ? create
              : () => alert("내용을 입력해주세요")
          }
        >
          회원 추가
        </MDButton>
      </MDBox>
    </Modal>
  );
}

function userDetailModal(
  open: boolean,
  setOpen: any,
  signdata: {
    email: string;
    name: string;
    tel: string;
    plan_grade: string;
    created_at: string;
    login_type: string;
    last_login: string;
    notification: string;
    marketing: string;
    info_consent: string;
    plan_start: string;
    plan_end: string;
  }
) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "32px",
        width: "100%",
        overflowY: "auto",
      }}
    >
      <MDBox
        bgColor="white"
        p="50px 40px"
        borderRadius="16px"
        display="flex"
        flexDirection="column"
        gap="25px"
        position={"relative"}
      >
        <Icon
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            cursor: "pointer",
            fontSize: 28,
            color: "#888",
            zIndex: 1,
          }}
        >
          close
        </Icon>
        <Table sx={{ minWidth: 500, border: "1px solid #0000001A" }} size="small">
          <TableBody>
            {[
              ["이메일", signdata.email],
              ["성명", signdata.name],
              ["연락처", signdata.tel.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")],
              [
                "회원등급",
                signdata.plan_grade
                  ? GRADE_TYPE[signdata.plan_grade as keyof typeof GRADE_TYPE] ??
                    signdata.plan_grade
                  : "-",
              ],
              ["가입일", signdata.created_at],
              ["가입채널", loginTypeMap[signdata.login_type as keyof typeof loginTypeMap]],
              ["최종방문일", signdata.last_login ? signdata.last_login : "-"],
              ["정보푸시알림수신", signdata.notification],
              ["마케팅수신동의", signdata.marketing],
              ["제3자정보제공동의", signdata.info_consent],
              ["이용권 시작일", signdata.plan_start ? signdata.plan_start : "-"],
              ["이용권 종료일", signdata.plan_end ? signdata.plan_end : "-"],
            ].map(([label, value], idx) => (
              <TableRow key={idx}>
                <TableCell
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  {label}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: 14,
                    border: "1px solid #0000001A",
                    fontFamily: "Pretendard",
                  }}
                >
                  {value}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </MDBox>
    </Modal>
  );
}

const sortData = [
  { label: "가입일 최신순", value: "RD" },
  { label: "가입일 오래된순", value: "RA" },
  { label: "방문일 최신순", value: "LD" },
  { label: "방문일 오래된순", value: "LA" },
];
